module.exports = __webpack_public_path__ + "static-m/img/tb.39210fc1.png";